<script>
const global = require ("../common/global.js")
export default {
  beforeCreate() {
    let query = this.$route.query;
    //this.$local.set("openId", "ocKf8waaFT03BEZxZAlDE0420l3A"); // y
    // this.$local.set('openId', 'oey1l5pqQKoh5eG63bBKbFSo5XcA') // h
    //this.$local.set("openId", "oK51KwymuyIQLv_9maaywygpz0rM"); // 支付测试
    // alert("111")
    if (query.token) {
      // this.$local.set("token", query.token);
      // alert("2222")
      window.localStorage.setItem("token",query.token);
    }
    
  },
};
</script>